import { render } from "./FooterComponent.vue?vue&type=template&id=77ff88d7&scoped=true"
const script = {}

import "./FooterComponent.vue?vue&type=style&index=0&id=77ff88d7&lang=postcss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77ff88d7"]])

export default __exports__